import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import CountUp from "react-countup";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from "../common/breadcrumbs";
import Aos from "aos";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { useLanguage } from "../../core/context/LanguageContext";


const AboutUs = () => {

  const { translations } = useLanguage();


  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <>
      {/* Breadscrumb Section */}
      <Breadcrumbs title={translations.aboutUs.breadcrumbs.title} subtitle={translations.aboutUs.breadcrumbs.subtitle} />
      {/* /Breadscrumb Section */}
      {/* About */}
      <Helmet>
        <title>{translations.aboutUs.helmet.title}</title>
        <meta name="description" content={translations.aboutUs.breadcrumbs.description} />
        <link rel="canonical" href="https://cardnd.com/aboutUs" />
      </Helmet>
      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-img">
                <div className="about-exp" style={{ paddingRight: "50px", display: "inline-block" }}>
                  <span >{translations.aboutUs.about.tagline}</span>
                </div>
                <div className="abt-img" >
                  <ImageWithBasePath
                    src="assets/img/about-us.png"
                    className="img-fluid"
                    alt="About us"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-content">
                <h6>{translations.aboutUs.about.title} </h6>
                <h2>{translations.aboutUs.about.subtitle} </h2>
                <p>
                  {translations.aboutUs.about.description[0]}
                </p>
                <p>
                  {translations.aboutUs.about.description[1]}
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul>
                      <li>{translations.aboutUs.about.features.left[0]}</li>
                      <li>{translations.aboutUs.about.features.left[1]}</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul>
                      <li>{translations.aboutUs.about.features.right[0]}</li>
                      <li>{translations.aboutUs.about.features.right[1]}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* /About */}
      {/* services */}
      <section className="section services bg-light-primary">
        <div className="service-right">
          <ImageWithBasePath
            src="assets/img/bg/service-right.svg"
            className="img-fluid"
            alt="services right"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>{translations.aboutUs.howItWorks.title}</h2>
            <p>

            </p>
          </div>
          {/* /Heading title */}
          <div className="services-work">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-secondary">
                    <ImageWithBasePath
                      className="icon-img bg-secondary"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{translations.aboutUs.howItWorks.steps[0].title}</h3>
                    <p>
                      {translations.aboutUs.howItWorks.steps[0].description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-warning">
                    <ImageWithBasePath
                      className="icon-img bg-warning"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{translations.aboutUs.howItWorks.steps[1].title}</h3>
                    <p>
                      {translations.aboutUs.howItWorks.steps[1].description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-dark">
                    <ImageWithBasePath
                      className="icon-img bg-dark"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{translations.aboutUs.howItWorks.steps[2].title} </h3>
                    <p>
                      {translations.aboutUs.howItWorks.steps[2].description}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      {/* /services */}

      <section className="section facts-number">
        <div className="facts-left">
          <ImageWithBasePath
            src="assets/img/bg/facts-left.png"
            className="img-fluid"
            alt="facts left"
          />
        </div>
        <div className="facts-right">
          <ImageWithBasePath
            src="assets/img/bg/facts-right.png"
            className="img-fluid"
            alt="facts right"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">{translations.aboutUs.facts.title}</h2>
            <p className="description text-white">

            </p>
          </div>
          {/* /Heading title */}
          <div className="counter-group">
            <div className="row">
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-heart.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={16000}
                          duration={3}
                          separator=","
                        />
                        K<br />
                      </h4>
                      <p> {translations.aboutUs.facts.data[0].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-car.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={2547}
                          duration={3}
                          separator=","
                        />
                        +<br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[1].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-headphone.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={625}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[2].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-history.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={200}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[3].description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-choose">
        <div className="choose-left">
          <ImageWithBasePath
            src="assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="Why Choose Us"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>{translations.aboutUs.whyChooseUs.title}</h2>

          </div>
          {/* /Heading title */}
          <div className="why-choose-group">
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-black">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[0].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[0].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-secondary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[1].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[1].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-primary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[2].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[2].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Why Choose Us */}
      {/* About us Testimonials */}
      {/* <section className="section about-testimonial testimonials-section">
        <div className="container"> */}
      {/* Heading title*/}
      {/* <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">What People say about us? </h2>
            <p className="description text-white">
              Lorem Ipsum has been the industrys standard dummy text ever since
              the 1500s,
            </p>
          </div> */}
      {/* /Heading title */}
      {/* <div className="owl-carousel about-testimonials testimonial-group mb-0 owl-theme"> */}
      {/* /Carousel Item  */}
      {/* Carousel Item */}
      {/* <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-item d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="quotes-head" />
                      <div className="review-box">
                        <div className="review-profile">
                          <div className="review-img">
                            <ImageWithBasePath
                              src={testimonial.image}
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="review-details">
                          <h6>{testimonial.name}</h6>
                          <div className="list-rating">
                            <div className="list-rating-star">
                              {[...Array(Math.floor(testimonial.rating))].map(
                                (_, i) => (
                                  <i key={i} className="fas fa-star filled" />
                                )
                              )}
                            </div>
                            <p>
                              <span>({testimonial.rating})</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider> */}

      {/* /Carousel Item  */}
      {/* Carousel Item */}

      {/* /Carousel Item  */}
      {/* </div>
        </div>
      </section> */}
      {/* About us Testimonials */}
      <>
        {/* FAQ  */}
        <section className="section faq-section bg-light-primary">
          <div className="container">
            {/* Heading title*/}
            <div className="section-heading" data-aos="fade-down">
              <h2>{translations.aboutUs.faqs.title}</h2>
              <p>
                {translations.aboutUs.faqs.description}
              </p>
            </div>
            {/* /Heading title */}
            <div className="faq-info">
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqOne"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[0].question}

                  </Link>
                </h4>
                <div id="faqOne" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[0].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqTwo"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[1].question}

                  </Link>
                </h4>
                <div id="faqTwo" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[1].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqThree"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[2].question}

                  </Link>
                </h4>
                <div id="faqThree" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[2].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqFour"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[3].question}

                  </Link>
                </h4>
                <div id="faqFour" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[3].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqFive"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[4].question}

                  </Link>
                </h4>
                <div id="faqFive" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[4].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqSix"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[5].question}

                  </Link>
                </h4>
                <div id="faqSix" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[5].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqSeven"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[6].question}

                  </Link>
                </h4>
                <div id="faqSeven" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[6].answer}

                  </p>
                </div>
              </div>

              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqEight"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[7].question}

                  </Link>
                </h4>
                <div id="faqEight" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[7].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqNine"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[8].question}

                  </Link>
                </h4>
                <div id="faqNine" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[8].answer}

                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* /FAQ */}
      </>
    </>
  );
};

export default AboutUs;
